
import Vue from 'vue'
import { Loading } from '@/components'

export default Vue.extend({
   name: 'TeachablesSignupProcessingBanner',
   components: {
      Loading,
   },
})
